export interface QuickBooksExportableBillConstructor {
  id: number // selection key for stage/archive/unstage
  groupId: string // "Bill" column label
  vendorName: string
  submittedDate: Date
  dueDate: Date
  uuid: string // detail link /bills/requests/{uuid}
  stagedForExport: boolean
}

export class QuickBooksExportableBill {
  readonly id: number
  readonly groupId: string
  readonly vendorName: string
  readonly submittedDate: Date
  readonly dueDate: Date
  readonly uuid: string
  readonly stagedForExport: boolean

  constructor(data: QuickBooksExportableBillConstructor) {
    this.id = data.id
    this.groupId = data.groupId
    this.vendorName = data.vendorName
    this.submittedDate = data.submittedDate
    this.dueDate = data.dueDate
    this.uuid = data.uuid
    this.stagedForExport = data.stagedForExport
  }
}
